// extracted by mini-css-extract-plugin
export default {"title":"login_title__2meL4","email":"login_email__1Zgr-","password":"login_password__bYARd","links":"login_links__DuvSR","validationError":"login_validationError__+BpTb"};